export const disclosuresCopy = {
  cover: {
    allData: "All data in this report is as of the report date listed above.",
    thisInformation:
      "This information is prepared exclusively at the specific request of, and for the sole use of the intended recipient and may contain privileged information.",
    anyUnauthorizedReview:
      "Any unauthorized review, use, disclosure or distribution is prohibited.  IMPORTANT: This material is provided exclusively to Allspring's financial intermediaries only for their internal use or for use with their clients or prospective clients to which the hypothetical performance contained within is relevant to the client's investment objectives and likely financial situation, and who have the resources and requisite experience or expertise to assess the hypothetical performance and understand its risks and limitations. All other uses of this material are unauthorized.",
  },
  report: {
    body: `
      <p>
      Investments in fixed-income securities are subject to market, interest
      rate, credit and other risks. Bond prices fluctuate inversely to
      changes in interest rates. Therefore, a general rise in interest rates
      can result in the decline in the bond’s price. Credit risk is the risk
      that an issuer will default on payments of interest and/or principal.
      This risk is heightened in lower rated bonds. If sold prior to
      maturity, fixed income securities are subject to market risk. All
      fixed income investments may be worth less than their original cost
      upon redemption or maturity.
      </p>
      <p>
      This material has been prepared by Allspring Global Investments, LLC,
      a registered Investment Advisor, and the material is intended for use
      by investment professionals with their clients. Allspring Global
      Investments does not provide accounting, legal, or tax advice or
      investment recommendations. Investors should consult their tax advisor
      or legal counsel for advice and information concerning their
      particular situation.
      </p>
      <p>
      Allspring Global Investments\u2122 is the trade name for the asset
      management firms of Allspring Global Investments Holdings, LLC, a
      holding company indirectly owned by certain private funds of GTCR LLC
      and Reverence Capital Partners, L.P. These firms include but are not
      limited to Allspring Global Investments, LLC, and Allspring Funds
      Management, LLC. Certain products managed by Allspring entities are
      distributed by Allspring Funds Distributor, LLC (a broker-dealer and
      Member FINRA/SIPC).
      </p>
    </>
    `,
  },
};

export const equityDisclosuresCopy = {
  report: {
    body: `
      <p>
      Source: MSCI. MSCI makes no express or implied warranties or
      representations and shall have no liability whatsoever with respect to
      any MSCI data contained herein. The MSCI data may not be further
      redistributed or used as a basis for other indices or any securities
      or financial products. This report is not approved, reviewed, or
      produced by MSCI.
      </p>
      <p>
      All investing involves risks, including the possible loss of
      principal. There can be no assurance that any investment strategy will
      be successful. Investments fluctuate with changes in market and
      economic conditions and in different environments due to numerous
      factors, some of which may be unpredictable. Each asset class has its
      own risk and return characteristics.
      </p>
      <p>
      This material has been prepared by Allspring Global Investments, LLC,
      a registered Investment Advisor, at the specific request of and
      exclusively for the use of the investment professional and his/her
      client. Allspring Global Investments does not provide accounting,
      legal, or tax advice or investment recommendations. Investors should
      consult their tax advisor or legal counsel for advice and information
      concerning their particular situation.
      </p>
      <p>
      Allspring Global Investments™ (Allspring) is the trade name for the
      asset management companies of Allspring Global Investments Holdings,
      LLC (Allspring Holdings), a holding company indirectly owned by
      certain private funds of GTCR LLC and Reverence Capital Partners, L.P.
      Unless otherwise stated, Allspring is the source of all data (which is
      current or as of the date stated); content is provided for
      informational purposes only with no representation regarding its
      adequacy, accuracy or completeness and should not be relied upon;
      views, opinions, assumptions or estimates are not necessarily that of
      Allspring Holdings, Allspring or their affiliates and are subject to
      change without notice; and this communication does not contain
      investment advice, an investment recommendation or investment
      research, as defined under local regulation of the respective
      jurisdiction.
      </p>
    `,
    footnote: `
    <p className="disclosures__footnote-item-content-legal">
      For Investment Professional Use Only In One-On-One Presentation With
      Client
    </p>
    `,
  },
};
